<template>
  <div class="buttons">
    <x-button
      v-for="(label, index) in buttonLabels"
      :key="`btn-${label}`"
      :class="{ selected: currentValue === index }"
      @click="() => onClick(index)"
    >
      {{ label }}
    </x-button>
  </div>
</template>

<script>
  export default {
    name: 'XButtonSwitch',
    props: {
      buttonLabels: {
        type: Array,
        required: true
      },
      defaultSelection: {
        type: Number,
        required: false,
        default: 0
      }
    },

    data () {
      return {
        currentValue: this.defaultSelection
      }
    },
    methods: {
      onClick (val) {
        if (this.currentValue !== val) {
          this.currentValue = val
          this.$emit('switchUpdate', val)
        }
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .buttons {
    display: flex;
    align-items: center;

    .button {
      font-weight: 600;
      font-size: 1.6rem;
      border-radius: 0;
      border: none;
      background-color: #FFFFFF;
      color: map_get($palette-primary, main);
      border-top: 1px solid map_get($palette-primary, main);
      border-bottom: 1px solid map_get($palette-primary, main);
      border-right: 1px solid map_get($palette-primary, main);

      &:first-of-type {
        border-left: 1px solid map_get($palette-primary, main);
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      &:last-of-type {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      &.selected {
        background-color: map_get($palette-primary, main);
        color: white;
      }
    }
  }
</style>
